import { Card, Container, Skeleton, Stack } from '@mui/material'

export default function CompanyLayoutLoader() {
  return (
    <>
      <Container maxWidth='xl' disableGutters>
        <Card
          elevation={0}
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            padding: '1.5rem',
            backgroundColor: 'background.default',
            width: '100%',
            justifyContent: 'space-between'
          }}
        >
          <Stack direction='row' alignItems='center' gap='1rem'>
            <Skeleton
              variant='rectangular'
              width={64}
              height={64}
              sx={{ borderRadius: '.25rem' }}
            />
            <Stack direction='column' gap='0.25rem'>
              <Skeleton
                variant='text'
                width={200}
                height={32}
                sx={{ fontSize: '1.25rem' }}
              />
              <Skeleton
                variant='rectangular'
                width={120}
                height={24}
                sx={{ borderRadius: '4px' }}
              />
            </Stack>
          </Stack>

          <Stack direction='row' spacing='1.5rem'>
            <Skeleton variant='text' width={120} height={20} />
            <Skeleton variant='text' width={160} height={20} />
            <Skeleton variant='text' width={150} height={20} />
          </Stack>
        </Card>

        <Stack direction='row' spacing={1} sx={{ marginBottom: '1rem' }}>
          <Skeleton
            variant='rectangular'
            width={120}
            height={42}
            sx={{ borderRadius: '0.5rem' }}
          />
          <Skeleton
            variant='rectangular'
            width={120}
            height={42}
            sx={{ borderRadius: '0.5rem' }}
          />
          <Skeleton
            variant='rectangular'
            width={120}
            height={42}
            sx={{ borderRadius: '0.5rem' }}
          />
          <Skeleton
            variant='rectangular'
            width={120}
            height={42}
            sx={{ borderRadius: '0.5rem' }}
          />
        </Stack>

        <Skeleton
          variant='rectangular'
          width='100%'
          height='40rem'
          sx={{ borderRadius: '0.5rem' }}
        />
      </Container>
    </>
  )
}
